// SuggestionActionSheet — Langdruck-Menü einer Vorschlags-Kachel im mobilen Hinzufügen-Modus:
// Karte ausblenden oder eines ihrer Begründungs-Themen stummschalten. Das Sheet schließt der
// Aufrufer nach Erfolg der Mutation; `busy` sperrt bis dahin alle Zeilen.
// Themen-Zeilen tragen das Label als Namen und die Aktion darunter: `List.Name` ist einzeilig,
// und in einem Satz „Thema … stummschalten“ würde ein langes Label das Verb abschneiden.
import React from 'react';
import BottomSheet from '../../../../ui/BottomSheet';
import List from '../../../../ui/List';

export default function SuggestionActionSheet({ entry, open, onOpenChange, onHide, onMuteTag, busy = false }) {
  if (!entry) return null;

  return (
    <BottomSheet open={open} onOpenChange={onOpenChange} title={entry.name}>
      <List>
        <List.Item onClick={() => onHide?.(entry)} disabled={busy}>
          <List.Main>
            <List.Name>Nicht mehr vorschlagen</List.Name>
          </List.Main>
        </List.Item>
        {(entry.reasons || []).map((grund) => (
          <List.Item key={grund.tagId} onClick={() => onMuteTag?.(grund.tagId)} disabled={busy}>
            <List.Main>
              <List.Name>{grund.label}</List.Name>
              <List.Meta>Thema stummschalten</List.Meta>
            </List.Main>
          </List.Item>
        ))}
      </List>
    </BottomSheet>
  );
}
